import { Injectable } from '@angular/core';

import { ICountry, INamedObject } from '../../../../../type_definitions/datatypes';
import { HttpDataService, IHttpDataCache } from '../../../../shared/http/http-data.service';
import { IOrderContext } from '../order-entry-data.service';

const CANCELID_CNTRY:string = 'loadCountries';
const CANCELID_BPCTX:string = 'loadBPsAndContext';

@Injectable()
export class OrderEntryWebshopDataService {
  private cache:IHttpDataCache<any>;

  constructor(
    private httpDataService:HttpDataService
  ) {
    this.cache = httpDataService.createCache();
  }

  public countries(webshopId:number, workflowType?:string, punchOutMessageId?:number):Promise<ICountry[]> {
    return this.httpDataService.doGET(
      `rest/orderentry/webshops/${webshopId}/countries`,
      {
        workflowType,
        punchOutMessageId
      },
      undefined,
      'Error loading countries',
      CANCELID_CNTRY
    );
  }

  public bps(webshopId:number, countryId:number, punchOutMessageId:number, workflowType?:string):Promise<INamedObject[]> {
    return this.httpDataService.doGET(
      `rest/orderentry/webshops/${webshopId}/countries/${countryId}/shipfrom`,
      {
        workflowType,
        punchOutMessageId
      },
      undefined,
      'Error loading BPs',
      CANCELID_BPCTX
    );
  }

  public shopContext(webshopId:number, countryId:number, companyCountryId:number, punchOutMessageId:number):Promise<IOrderContext> {
    return this.cache.doGET(
      `rest/orderentry/webshops/${webshopId}/countries/${countryId}/context`,
      {
        companyCountryId,
        punchOutMessageId
      },
      undefined,
      'Error loading shopContext',
      CANCELID_BPCTX
    );
  }
}